/* eslint-disable global-require */
module.exports = ['payments.platforms.paypal.m1'];
